export const isAbortError = (error: unknown): error is { name: 'AbortError' } =>
    typeof error === 'object' && error !== null && 'name' in error && error.name === 'AbortError';
